module.exports = __webpack_public_path__ + "static/img/13.2fc1779.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/zh/13.png
// module id = odBI
// module chunks = 0